import {
	createContext,
	type Dispatch,
	type SetStateAction,
	useContext,
	useMemo,
	useState,
} from "react"

interface ActiveChatApi {
	/** The chat the user is currently viewing (open + on screen), or null. */
	activeChatId: string | null
	setActiveChatId: Dispatch<SetStateAction<string | null>>
}

const ActiveChatCtx = createContext<ActiveChatApi | null>(null)

/**
 * Tracks which shared chat is currently open (ZPL-147), so the mention-toast
 * listener can suppress a toast for the chat the user is already looking at.
 */
export function ActiveChatProvider({
	children,
}: {
	children: React.ReactNode
}) {
	const [activeChatId, setActiveChatId] = useState<string | null>(null)
	const value = useMemo(
		() => ({ activeChatId, setActiveChatId }),
		[activeChatId],
	)
	return (
		<ActiveChatCtx.Provider value={value}>{children}</ActiveChatCtx.Provider>
	)
}

export function useActiveChat(): ActiveChatApi {
	const ctx = useContext(ActiveChatCtx)
	if (!ctx)
		throw new Error("useActiveChat must be used within ActiveChatProvider")
	return ctx
}
